export const EditOrCreate = (isEditing: boolean, entity: string, preposition = 'a') => ({
        toast: `${entity} ${isEditing ? `atualizad${preposition}.` : `adicionad${preposition}.`}`,
        title: `${isEditing ? `Atualizar ${entity}` : `Adicionar ${entity}`}`,
    }
);

export const ActivatedOrInactivated = (isActive: boolean, entity: string, prep= 'a') => ({
    toast: `${entity} ${isActive ? `ativad${prep}.` : `inativad${prep}.`}`,
});

export const Deleted = (entity: string, prep = 'a') => ({
    toast: `${entity} excluíd${prep}.`,
});

export const ButtonText = (entity: string) => ({
    add: `Adicionar ${entity}`,
});

export const Field = {
    required: 'Este campo é obrigatório.',
    email: 'E-mail inválido.',
    invalid: 'Campo inválido.',
    minArr: (min: number, entity: string) => `É necessário adicionar no mínimo ${min} ${entity}.`,
}

export const Tip = (entity: string) => ({
    view: `Visualizar ${entity}`,
    edit: `Editar ${entity}`,
    toggleActive: `Ativar/Desativar ${entity}`,
    delete: `Excluir ${entity}`,
});
